import isEmpty from 'lodash/isEmpty';

import * as api from '../api/adapters/json_api';

// The templates of the documents issued every period (FIN-1266).
//
// A template is never posted from attributes: it is BUILT from an order (or an
// invoice) that was issued by hand, and later UPDATED from a document it
// generated. A PATCH changes the schedule and the owners; the snapshot itself
// only moves through `updateFromDocuments`.
const type = 'api_resources/recurring_templates';
const resourceType = 'recurring_templates';

const sortOptions = (sort) => (!sort || isEmpty(sort.field)
  ? 'name'
  : `${sort.direction === 'asc' ? '' : '-'}${sort.field}`);

export default {
  index: (pagination, sort, search, filter) => api.read({ type }, {
    query: {
      sort: sortOptions(sort),
      filter: { ...filter, ...(search ? { search } : {}) },
      page: { size: pagination.itemsPerPage, number: pagination.activePage },
    },
  }),

  // The templates a company is billed with — the company card's Recurring tab.
  forCustomer: (customerId) => api.read({ type }, {
    query: { filter: { customer_id: customerId }, page: { size: 100, number: 1 } },
  }),

  show: (id) => api.read({ type, id }, {}),

  update: (id, attributes) => api.update({ type, id }, {}, { data: { id: String(id), type: resourceType, attributes } }),

  delete: (id) => api.destroy({ type, id }),

  // "Make template": { purchase_order_id | invoice_id, name, frequency, issue_day,
  // starts_on, ends_on, payment_terms, order_owner_id, invoice_owner_id }.
  build: (params) => api.create({ type, action: 'build' }, {}, params),

  // What the next period would carry — or the period asked for ("2026-10").
  preview: (id, period) => api.read({ type, id, action: 'preview' }, period ? { query: { period } } : {}),

  versions: (id) => api.read({ type, id, action: 'versions' }, {}),

  // "Update template": the documents of one generated period become the next version.
  updateFromDocuments: (id, params) => api.create({ type, id, action: 'update_from_documents' }, {}, params),
};
